import type { AskRedoUIMessage } from "../types";
import { settlePendingToolPart } from "./settle-pending-tool-part";

/** Reconciles a tool result persisted outside the AI SDK approval transport. */
export function settleToolPart(
  messages: AskRedoUIMessage[],
  toolCallId: string,
  output: unknown,
): AskRedoUIMessage[] {
  return settlePendingToolPart(messages, toolCallId, {
    state: "output-available",
    output,
  });
}
